import React, { useState } from "react";
import { useEffect } from "react";
import { url } from "../../Constant";
import axios from "axios";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
import FilterModal from "../../components/Modal/FilterModal";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const NewExtToExt = () => {
  const accessVpbxId = sessionStorage.getItem("companyData");
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [size, setSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [extensionData, setExtensionData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [apicalled, setApiCalled] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [dateError, setDateError] = useState("");
  const [error, setError] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [filterData, setFilterData] = useState({
    start_date: null,
    end_date: null,
    duration_type: "",
    duration: null,
    condition: null,
    agent_number: "",
    customer_number: "",
  });

  const getExtesnion = (page) => {
    let api = "";
    if (auth.role === "1") {
      api = "super-ext-to-ext";
    } else if (auth.role === "2") {
      api = `ext-to-ext`;
    } else {
      api = `user-ext-to-ext`;
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
          page: page,
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          agent_number: filterData.agent_number,
          customer_number: parseInt(filterData.customer_number),
          duration_type: filterData.duration_type,
          duration: filterData.duration,
          condition: filterData.condition,
          limit: size,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setExtensionData([]);
            } else if (response.data.message === "Data Found") {
              setExtensionData(response.data.data.extensionCalls);
              setPageCount(response.data.data.pages);
            }
          } else {
            setExtensionData([]);
            setPageCount(0);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };
  const getFilterData = () => {
    var Errorvariable = "";
    if (
      filterData.start_date === null &&
      filterData.end_date === null &&
      filterData.agent_number === "" &&
      filterData.customer_number === "" &&
      filterData.duration_type === ""
    ) {
      Errorvariable = "Please select parameters for filter";
      setError(Errorvariable);
    }
    if (Errorvariable === "" && dateError === "") {
      axios
        .post(
          url + "/ext-to-ext",
          {
            vpbx_id: auth.vpbx_id,
            start_date: filterData.start_date,
            end_date: filterData.end_date,
            agent_number: filterData.agent_number,
            customer_number: filterData.customer_number,
            duration_type: filterData.duration_type,
            duration: filterData.duration,
            condition: filterData.condition,
            limit: size,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          },
        )
        .then(
          (response) => {
            if (response.status === 200) {
              setLoader(false);

              if (
                response.data.message === "Data Not Found" &&
                response.data.data.length === 0
              ) {
                setExtensionData([]);
              } else if (response.data.message === "Data Found") {
                setExtensionData(response.data.data.extensionCalls);
                setPageCount(response.data.data.pages);
              }
              handleCloseFilterModal();
            }
          },
          (error) => {
            console.log(error);
          },
        );
    }
  };

  useEffect(() => {
    if (apicalled === true) {
      getExtesnion(1);
    }
  }, [apicalled]);

  useEffect(() => {
    setLoader(true);
    getExtesnion(currentPage);
  }, [size]);

  //   const handleOpenFilterModal = () => {
  //     setOpenFilterModal(true);
  //   };
  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredDataExtToExt = extensionData.filter((val) => {
    return (
      (val.src && val.src.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.dst && val.dst.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.duration &&
        typeof val.duration === "string" &&
        val.duration.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.call_response &&
        val.call_response.toLowerCase().includes(searchText.toLowerCase())) ||
      (val.calldate &&
        val.calldate.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handleExportData = () => {
    setDownloadLoader(true);
    let api = "";
    if (auth.role === "1") {
      api = "super-downloadCdrs";
    } else if (auth.role === "2") {
      api = "downloadCdrs";
    } else {
      api = "user-downloadCdrs";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.role === "1" ? accessVpbxId : auth.vpbx_id,
          call_type: "ext_ext",
          start_date: filterData.start_date,
          end_date: filterData.end_date,
          agent_number: filterData.agent_number,
          customer_number: filterData.customer_number,
          duration_type: filterData.duration_type,
          duration: filterData.duration,
          condition: filterData.condition,
          limit: size,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setDownloadLoader(false);

            window.location.href = response.data.data;
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  const handlePageChange = (data) => {
    setLoader(true);
    getExtesnion(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };

  return (
    // <div className="dashboardWrp">
    //   <div className="uk-container uk-container-large">
    //     <div className="dashboardTop">
    //       <div uk-grid="" className="uk-grid uk-grid-small">
    //         <div className="uk-width-2-3">
    //           <div className="dashboardIntro">
    //             <h3>CALL RECORDS</h3>
    //             {auth.role === "2" && (
    //               <p>
    //                 Use this page to view the call logs or call history,
    //                 including inbound, outbound, and missed calls.
    //               </p>
    //             )}
    //           </div>
    //         </div>

    //         <div className="uk-width-1-1 ">
    //           <ul
    //             className="uk-subnav callSwitcher"
    //             uk-switcher="connect: .callClass"
    //           >
    //             {(auth.role === "2" || auth.role === "3") && (
    //               <>
    //                 {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //                   <li onClick={() => navigate("/incoming-calls")}>
    //                     <a href="#">Incoming calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //                   <li onClick={() => navigate("/outgoing-calls")}>
    //                     <a href="#">Outgoing calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //                   <li onClick={() => navigate("/missed-calls")}>
    //                     <a href="#">Offtime calls</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.role === "2" ||
    //                 checkPermissions("ext-to-ext-calls") ? (
    //                   <li
    //                     className="uk-active"
    //                     onClick={() => navigate("/ext-to-ext")}
    //                   >
    //                     <a href="#">Ext. to Ext.</a>
    //                   </li>
    //                 ) : null}
    //                 {auth.call_initiated === "1" ? (
    //                   <li onClick={() => navigate("/feedback")}>
    //                     <a href="#">Feedback</a>
    //                   </li>
    //                 ) : null}
    //               </>
    //             )}
    //           </ul>
    //         </div>
    //       </div>
    //       <ul className="uk-switcher uk-margin callClass">
    //         {(auth.role === "2" || auth.role === "3") && (
    //           <>
    //             {auth.role === "2" || checkPermissions("incoming-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("outgoing-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("offtime-calls") ? (
    //               <li></li>
    //             ) : null}
    //             {auth.role === "2" || checkPermissions("ext-to-ext-calls") ? (
    //               <li>
    <div className="ImcomingCallMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            <div className="CustomSearch">
              <form className="uk-search uk-search-default">
                {/* <span uk-search-icon=""></span> */}

                <input
                  className="uk-search-input"
                  type="text"
                  placeholder="Search by all field"
                  value={searchText}
                  onChange={handleSearch}
                />
              </form>
            </div>
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                {(auth.role === "1" ||
                  auth.role === "2" ||
                  checkIndividualPermission(
                    "ext-to-ext-calls",
                    "read_and_write",
                  )) && (
                  <>
                    <button
                      className="exportData-button"
                      onClick={handleExportData}
                    >
                      {downloadLoader ? (
                        <div uk-spinner=""></div>
                      ) : (
                        "Export Data"
                      )}
                    </button>
                  </>
                )}
              </div>
            </span>
            <span className="primary-color"></span>
          </div>
        </div>
      </div>
      {loader ? (
        <div uk-spinner="" className="tableloader"></div>
      ) : filteredDataExtToExt.length === 0 ? (
        <div className="customtableNoDataText">
          There are no records to display
        </div>
      ) : (
        <div className="customTable">
          <table>
            <thead>
              <tr>
                <th>Incoming Number</th>
                <th>Destination</th>
                <th>Duration</th>
                <th>Call Response</th>
                <th>Time</th>
                <th>Recording</th>
              </tr>
            </thead>
            <tbody>
              {filteredDataExtToExt.map((val, index) => (
                <>
                  <tr key={index}>
                    <td>{val.src}</td>
                    <td>{val.dst}</td>
                    <td>{val.duration}</td>
                    <td>{val.call_response}</td>
                    <td>{val.calldate}</td>

                    <td>
                      <audio
                        className="mp3Audio"
                        controls
                        target="_blank"
                        rel="noopener noreferrer"
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source
                          // src={
                          //   process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                          //   `${auth.vpbx_id}/` +
                          //   moment(val.start_call_date).format("YYYYMMDD") +
                          //   `/${val.call_type}/` +
                          //   `${val.userfield}.wav`
                          // }
                          src={
                            process.env.REACT_APP_CALL_RECORDS_AUDIO_URL +
                            `${auth.role === "1" ? accessVpbxId : auth.vpbx_id}/` +
                            moment(val.start_call_date).format("YYYYMMDD") +
                            `/${val.call_type}/` +
                            `${val.userfield}.wav`
                          }
                        />
                        Your browser does not support the audio tag.
                      </audio>
                    </td>
                  </tr>
                  <br />
                </>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="tablePaginationBox ">
        <div className="uk-margin-left">
          Show{" "}
          <select onChange={(e) => setSize(e.target.value)}>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          entries
        </div>
        <div>
          {pageCount > 1 && (
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={"...."}
              pageCount={pageCount}
              onPageChange={handlePageChange}
              containerClassName={
                "uk-pagination uk-float-right contatPagination"
              }
              activeClassName={"uk-active"}
              marginPagesDisplayed={3}
              pageRangeDisplayed={6}
            />
          )}
        </div>
      </div>
      {openFilterModal && (
        <FilterModal
          closeModal={handleCloseFilterModal}
          // filterModalDescTxt="Search by any date, country, city, gender, tags or Status"
          setFilterData={setFilterData}
          filterData={filterData}
          setApiCalled={setApiCalled}
          getFilterData={getFilterData}
          setDateError={setDateError}
          dateError={dateError}
          error={error}
          setError={setError}
        />
      )}
    </div>
    //                 </li>
    //             ) : null}
    //             {auth.call_initiated === "1" ? <li></li> : null}
    //           </>
    //         )}
    //       </ul>
    //     </div>
    //   </div>
    // </div>
  );
};

export default NewExtToExt;
